/* jshint esversion: 8 */

/**
 * Code from:
 * https://github.com/ffmpegwasm/ffmpeg.wasm
 */

; (
	function() {

		const IS_COMPATIBLE = typeof SharedArrayBuffer === 'function';
		if ( !IS_COMPATIBLE ) {
			document.getElementById( 'incompatible' ).style.display = 'block';

			document.getElementById( 'input' ).style.display = 'none';
			document.getElementById( 'output' ).style.display = 'none';

			return;
		}


		const { createFFmpeg, fetchFile } = FFmpeg;

		const defaultMessage = `<small>Note: this may take a while.</small>`;

		// Get all the things.
		const message = document.getElementById( 'message' );
		const uploader = document.getElementById( 'uploader' );
		const video = document.getElementById( 'output-video' );
		const download_link = document.getElementById( 'output-download' );


		/**
		 * Generate the ffmpeg file that we will use later.
		 */
		const ffmpeg = createFFmpeg(
			{
				log: true,
				progress: ( { ratio } ) => {
					message.innerHTML = `Complete: ${( ratio * 100.0 ).toFixed( 2 )}%`;
				},
			}
		);


		/**
		 * Convert the video.
		 */
		const transcode = async ( { target: { files } } ) => {

			const { name } = files[ 0 ];
			message.style.display = 'block';

			document.getElementById( 'input-uploader' ).style.display = 'none';

			// Load ffmpeg, but only if not already loaded.
			if ( !ffmpeg.isLoaded() ) {
				message.innerHTML = '<div class="bg-black p3 b-br2"><div class="loading">Preparing ...</div></div>';
				await ffmpeg.load();
			}

			// Create the video.
			// https://cspeterson.net/converting-gifs-mp4-instagram-ffmpeg/
			message.innerHTML = 'Converting';
			ffmpeg.FS( 'writeFile', name, await fetchFile( files[ 0 ] ) );

			// New file name.
			let new_name = name;
			// Get file extension.
			// This makes the code more flexible in case I add any other formats.
			let extension = name.split( '.' ).pop();
			new_name = new_name.replace( '.' + extension, target_filetype );
			console.log( 'filename', new_name, extension );

			switch ( target_filetype ) {
				case '.mp3':
					console.log( 'mp3' );
					await ffmpeg.run( '-i', name, '-vn', '-ar', '44100', '-ac', '2', '-ab', '192k', '-f', 'mp3', new_name );
					break;

				case '.webm':
					console.log( 'webm' );
					await ffmpeg.run( '-i', name, '-c:v', 'libvpx', new_name );
					break;

				case '.gif':
					console.log( 'gif' );
					// https://superuser.com/questions/556029/how-do-i-convert-a-video-to-gif-using-ffmpeg-with-reasonable-quality
					await ffmpeg.run( '-i', name, '-pix_fmt', 'rgb24', '-loop', 0, new_name );
					break;

				default:
				case '.mp4':
					console.log( 'mp4' );

					await ffmpeg.run( '-i', name, '-pix_fmt', 'yuv420p', new_name );
					break;
			}

			// Video complete, grab the data and display everything.
			message.innerHTML = 'Complete!';
			const data = ffmpeg.FS( 'readFile', new_name );

			document.getElementById( 'input' ).style.display = 'none';
			document.getElementById( 'output' ).style.display = 'block';
			download_link.setAttribute( 'download', new_name );

			/**
			 * Generate the file blob to display in the video player, and add to the
			 * download link.
			 */
			const video_blob = URL.createObjectURL(
				new Blob(
					[ data.buffer ],
					{ type: target_file_format }
				)
			);

			video.src = video_blob;
			download_link.href = video_blob;

			console.log( new_name, video_blob, download_link );

		};


		/**
		 *
		 */
		const resetUploadForm = function() {

			document.getElementById( 'input' ).style.display = 'block';
			document.getElementById( 'input-uploader' ).style.display = 'flex';

			const outputButton = document.getElementById( 'output' );
			outputButton.style.display = 'none';

			message.innerHTML = defaultMessage;
			uploader.value = '';

		};

		resetUploadForm();

		// Events.
		document.getElementById( 'output-again' ).addEventListener( 'click', resetUploadForm );
		uploader.addEventListener( 'change', transcode );

	}
)();
